import axios from "axios";

const URL_AGENTS = import.meta.env.VITE_AGENTS;

export function CreateNewCompaniesService(token, data) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(data);
      const response = await axios.post(
        `${URL_AGENTS }/api/admin/v1/business`,
        data,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      resolve(response.data.data);
    } catch (error) {
      reject(error);
    }
  });
}